import { graphql, useStaticQuery } from 'gatsby';

export const useNeighborhoodsMapQuery = () => {
    const data = useStaticQuery(graphql`
{
    allSmartTagsNeighborhoodsMap(
        filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
    ) {
        edges {
            node {
                id
                title
                flush
                useSlider
                fullWidth
                type
                permalink
            }
        }
    }
}
`);
    return { data };
};